import { FC, useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Actions
import { updateDefaultAddress, deleteAddress } from "../../../../../actions/shipperAction";

//Components
import Component from "./Component";

//Interfaces
import { AddressInterface } from "../../definitions";
import { WrapperInterface } from "./definitions";


const SelectPickupAddress: FC<WrapperInterface> = ({ addEditAddress, onBack, fetchingAddressList, ListAddresses, fetchAddressList, confirmAction }) => {
  const [openConfirmation, setOpenConfirmation] = useState(false)
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false)
  const [loading, setLoading] = useState<boolean | undefined>(false)

  // This is for delete, edit, set default address
  const [selectedAddress, setSelectedAddress] = useState<AddressInterface | null>(null)

  // This is for choose pickup address
  const [choosenAddress, setChoosenAddress] = useState<AddressInterface | null>(null)

  /**Handlers */
  //API hadnlers
  const updateDefaultAddressHandler = async () => {
    try {
      setLoading(true)
      await updateDefaultAddress(selectedAddress?.id)
        .then(res => fetchAddressList())
        .catch(err => console.log(err))
        .finally(() => {
          setLoading(false)
          cancelDefaultHandler()
        })
    } catch (err) {
      setLoading(false)
      console.log(err, "Error when update default address")
    }
  }

  const deleteAddressAction = async () => {
    try {
      setLoading(true)
      await deleteAddress(selectedAddress?.id)
        .then(res => fetchAddressList())
        .catch(err => console.log(err))
        .finally(() => {
          setLoading(false)
          cancelDeleteAddressHandler()
        })
    } catch (err) {
      setLoading(false)
      console.log(err, "Error when deleting address")
    }
  }

  // Modal Confirmation handlers
  const setDefaultHandler = (addrs: AddressInterface) => {
    setOpenConfirmation(true)
    setSelectedAddress(addrs)
  }

  const cancelDefaultHandler = () => {
    setOpenConfirmation(false)
    setSelectedAddress(null)
  }

  const deleteAddressHandler = (addrs) => {
    setOpenDeleteConfirmation(true)
    setSelectedAddress(addrs)
  }

  const cancelDeleteAddressHandler = () => {
    setOpenDeleteConfirmation(false)
    setSelectedAddress(null)
  }

  const confirmHandler = () => confirmAction(choosenAddress || {})

  /**Use effects */
  useEffect(() => {
    setLoading(fetchingAddressList)
  }, [fetchingAddressList])

  return (
    <Component
      ListAddresses={ListAddresses}
      loading={loading}
      openDeleteConfirmation={openDeleteConfirmation}
      openConfirmation={openConfirmation}
      choosenAddress={choosenAddress}
      deleteAddressHandler={deleteAddressHandler}
      setDefaultHandler={setDefaultHandler}
      onBack={onBack}
      addEditAddress={addEditAddress}
      cancelDeleteAddressHandler={cancelDeleteAddressHandler}
      cancelDefaultHandler={cancelDefaultHandler}
      deleteAddressAction={deleteAddressAction}
      updateDefaultAddressHandler={updateDefaultAddressHandler}
      setChoosenAddress={setChoosenAddress}
      confirmHandler={confirmHandler}
    />
  )
}
SelectPickupAddress.defaultProps = {
  fetchingAddressList: false,
  ListAddresses: [],
  addEditAddress: () => { },
  onBack: () => { },
  fetchAddressList: () => { }
}

export default SelectPickupAddress;